module.exports = __webpack_public_path__ + "img/GEDIA_120X35.d8fe7d5c.png";